module.exports = __webpack_public_path__ + "static/img/login1.63e68880.jpg";